import React from "react";
import { Table, Card, Button } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "StyleFeatures/SoftBox";
import Footer from "Common/Footer";
import usePerformance from "Hooks/AdminHooks/usePerformance";
import { useNavigate } from "react-router-dom";

function Performance() {
  const navigate = useNavigate();
  const {
    departments,
    loading,
    handleDepartmentChange,
    handleDownloadReport,
    columns,
    selectedDepartment,
    employees,
  } = usePerformance();

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card 
          title="Employees Performance  Review" 
          className="card-professional"
          extra={  <Button className="btn-back" onClick={() => navigate(-1)}>Back</Button>   }
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <SoftBox color="text" style={{ marginRight: "20px" }}>
                <div style={{ display: "inline-block" }}>
                  <Button className="btn-primary" onClick={handleDownloadReport}>
                    <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Download Employee
                    Reports
                  </Button>
                </div>
              </SoftBox>
              <div className="mb-3" style={{ display: "inline-block" }}>
                <select
                  className="form-select form-select-sm"
                  value={selectedDepartment}
                  onChange={handleDepartmentChange}
                >
                  <option value="All Departments">All Departments</option>
                  {departments.map((department) => (
                    <option key={department} value={department}>
                      {department}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <Table
                className="custom-table"
                columns={columns}
                dataSource={employees}
                loading={loading}
                rowKey={(record) => record.employeeId || record.id}
              />
            </div>
          </Card>
          <Footer />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Performance;
